import { tokens } from '@cast/design-system';

export const clusterColors = {
  provisioned: tokens.theme.data.blue700,
  used: tokens.theme.data.green300,
  requested: tokens.theme.data.blue300,
  allocatable: tokens.theme.data.grey800,
  overhead: tokens.theme.data.grey400,
  idle: tokens.theme.data.yellow400,
  notUsed: tokens.theme.data.red200,
  utilization: tokens.theme.data.yellow800,
};
